import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['segment', 'remainder', 'source']
  static values = {
    total: { type: Number, default: 0 },
    fixed: { type: Number, default: 0 },
    locale: { type: String, default: 'fr' }
  }

  connect () {
    this.paint(this.current())
  }

  apply (event) {
    this.paint(Number(event.detail?.value))
  }

  current () {
    if (!this.hasSourceTarget) return 0

    const value = Number(this.sourceTarget.value)
    return Number.isFinite(value) ? value : 0
  }

  paint (adjustable) {
    const safe = Number.isFinite(adjustable) ? adjustable : 0
    const total = this.totalValue
    const fixed = Math.min(this.fixedValue, Math.max(total, 0))
    const remainder = Math.max(total - fixed - safe, 0)
    const parts = [fixed, safe, remainder]
    this.segmentTargets.forEach((segment, index) => {
      const width = total <= 0 ? 0 : (parts[index] / total) * 100
      segment.style.width = `${width}%`
    })
    if (!this.hasRemainderTarget) return

    this.remainderTarget.textContent = new Intl.NumberFormat(this.localeValue, {
      style: 'currency',
      currency: 'EUR',
      maximumFractionDigits: 0
    }).format(remainder)
  }
}
